/* HM: gösterim amaçlı kur çevirici (TRY -> USD/EUR). Ödeme mağaza para biriminde alınır. */
(function () {
  'use strict';
  var HM = window.HM || {};
  if (!HM.moneyTpl || window.__hmFx) return;
  window.__hmFx = true;

  var BASE = HM.currency || 'TRY';
  var LIST = HM.fxList && HM.fxList.length ? HM.fxList : [BASE];
  var KEY = 'hm_fx_currency';
  var RKEY = 'hm_fx_rates_' + BASE;
  var TTL = 3 * 60 * 60 * 1000;
  var SYMBOLS = { TRY: '₺', USD: '$', EUR: '€', GBP: '£' };
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, TEMPLATE: 1, SVG: 1 };

  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  var current = read(KEY);
  if (LIST.indexOf(current) === -1) current = BASE;
  var rates = null;

  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function parser(tpl) {
    var first = tpl.search(/\d/), last = tpl.length - tpl.split('').reverse().join('').search(/\d/);
    var pre = tpl.slice(0, first), suf = tpl.slice(last), num = tpl.slice(first, last);
    var dec = /\D\d{2}$/.test(num) ? num.charAt(num.length - 3) : '';
    var th = /^\d\D/.test(num) ? num.charAt(1) : '';
    if (!pre.trim() && !suf.trim()) return null;
    var body = '\\d{1,3}(?:' + (th ? escRe(th) : '') + '\\d{3})*' + (dec ? '(?:' + escRe(dec) + '\\d{2})?' : '');
    if (!th) body = '\\d+' + (dec ? '(?:' + escRe(dec) + '\\d{2})?' : '');
    return {
      re: new RegExp('(^|[^\\d.,])(-?)' + escRe(pre) + '(' + body + ')' + escRe(suf), 'g'),
      toNumber: function (s) {
        if (th) s = s.split(th).join('');
        if (dec) s = s.replace(dec, '.');
        return parseFloat(s);
      },
      marker: (pre + suf).trim()
    };
  }
  var parsers = [HM.moneyWcTpl, HM.moneyTpl].filter(Boolean).map(parser).filter(Boolean);
  if (!parsers.length) return;
  var markers = parsers.map(function (p) { return p.marker; });

  var formatters = {};
  function fmt(amount, code) {
    if (!formatters[code]) {
      try { formatters[code] = new Intl.NumberFormat(HM.locale || document.documentElement.lang || 'tr', { style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
      catch (e) { formatters[code] = { format: function (v) { return (SYMBOLS[code] || code + ' ') + v.toFixed(2); } }; }
    }
    return formatters[code].format(amount);
  }

  function convertText(text) {
    var rate = rates && rates[current];
    if (!rate) return text;
    parsers.forEach(function (p) {
      text = text.replace(p.re, function (m, lead, neg, n) {
        var v = p.toNumber(n);
        if (isNaN(v)) return m;
        return lead + (neg ? '-' : '') + fmt(v * rate, current);
      });
    });
    return text;
  }

  var owned = new Map();
  function hasMarker(s) {
    if (!/\d/.test(s)) return false;
    for (var i = 0; i < markers.length; i++) if (s.indexOf(markers[i]) > -1) return true;
    return false;
  }
  function skipNode(node) {
    for (var el = node.parentNode; el && el !== document.body; el = el.parentNode) {
      if (el.nodeType !== 1) continue;
      if (SKIP[el.nodeName.toUpperCase()] || el.isContentEditable || el.hasAttribute('data-hm-fx-skip')) return true;
    }
    return false;
  }
  function handle(node) {
    var rec = owned.get(node);
    if (rec && node.data === rec.shown) return;
    var original = node.data;
    if (!hasMarker(original) || skipNode(node)) { if (rec) owned.delete(node); return; }
    var shown = current === BASE ? original : convertText(original);
    owned.set(node, { original: original, shown: shown });
    if (shown !== original) { applying = true; node.data = shown; applying = false; }
  }
  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { handle(root); return; }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n; while ((n = w.nextNode())) handle(n);
  }
  function applyAll() {
    applying = true;
    owned.forEach(function (rec, node) {
      if (!node.isConnected) { owned.delete(node); return; }
      var shown = current === BASE ? rec.original : convertText(rec.original);
      rec.shown = shown;
      if (node.data !== shown) node.data = shown;
    });
    applying = false;
    scan(document.body);
    updateUi();
  }

  var applying = false, queue = [], scheduled = false;
  function flush() {
    scheduled = false;
    var q = queue; queue = [];
    q.forEach(function (n) { if (n.isConnected) scan(n); });
  }
  var observer = new MutationObserver(function (list) {
    if (applying) return;
    list.forEach(function (m) {
      if (m.type === 'characterData') queue.push(m.target);
      else m.addedNodes.forEach(function (n) { queue.push(n); });
    });
    if (!scheduled && queue.length) { scheduled = true; requestAnimationFrame(flush); }
  });

  function updateUi() {
    document.querySelectorAll('[data-hm-fx-current]').forEach(function (el) { el.textContent = (SYMBOLS[current] || '') + ' ' + current; });
    document.querySelectorAll('[data-hm-fx-symbol]').forEach(function (el) { var c = el.getAttribute('data-hm-fx-symbol'); el.textContent = (SYMBOLS[c] || '') + ' ' + c; });
    document.querySelectorAll('[data-hm-fx-set]').forEach(function (b) {
      var on = b.getAttribute('data-hm-fx-set') === current;
      b.classList.toggle('is-current', on);
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-hm-fx-note]').forEach(function (el) { el.hidden = current === BASE; });
    document.documentElement.setAttribute('data-hm-currency', current);
  }

  function loadRates() {
    var cached = null;
    try { cached = JSON.parse(read(RKEY) || 'null'); } catch (e) {}
    if (cached && cached.rates && Date.now() - cached.t < TTL) return Promise.resolve(cached.rates);
    return fetch('https://open.er-api.com/v6/latest/' + BASE)
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j.result !== 'success' || !j.rates) throw new Error('er-api'); return j.rates; })
      .catch(function () {
        return fetch('https://api.frankfurter.dev/v1/latest?base=' + BASE)
          .then(function (r) { return r.json(); })
          .then(function (j) { if (!j.rates) throw new Error('frankfurter'); return j.rates; });
      })
      .then(function (r) { store(RKEY, JSON.stringify({ t: Date.now(), rates: r })); return r; })
      .catch(function () { return cached ? cached.rates : null; });
  }

  function setCurrency(code) {
    if (LIST.indexOf(code) === -1) return;
    current = code;
    store(KEY, code === BASE ? null : code);
    if (code === BASE) { applyAll(); document.dispatchEvent(new CustomEvent('hm:currency', { detail: { currency: code } })); return; }
    loadRates().then(function (r) {
      rates = r;
      if (!r || !r[code]) { current = BASE; store(KEY, null); }
      applyAll();
      document.dispatchEvent(new CustomEvent('hm:currency', { detail: { currency: current } }));
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hm-fx-set]');
    if (b) {
      e.preventDefault();
      setCurrency(b.getAttribute('data-hm-fx-set'));
      var d = b.closest('details'); if (d) d.removeAttribute('open');
      return;
    }
    document.querySelectorAll('[data-hm-ls-dd][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-hm-ls-dd][open]').forEach(function (d) { d.removeAttribute('open'); });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-hm-ls-dd]') || !d.open) return;
    document.querySelectorAll('[data-hm-ls-dd][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
  }, true);

  function start() {
    scan(document.body);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    updateUi();
    if (current !== BASE) setCurrency(current);
  }
  HM.fx = { set: setCurrency, get: function () { return current; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
